import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { formatDocumentFilename } from '@/utils/helpers'

export const useOrderSignRequest = (id: string | undefined) => {
  return useQuery({
    queryKey: ['orderSignRequest', id],
    // Cache only the JSON payload, never the Axios response wrapper.
    queryFn: async () => {
      const { data } = await axios.get(`/api/sign/get/${id}`)
      return data
    },
    enabled: !!id,
  })
}

export const downloadSignDocument = async (id: string) => {
  try {
    const response = await axios.get(`/api/sign/download/${id}`, {
      responseType: 'blob',
    })

    const blob = new Blob([response.data], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url

    const contentDisposition = response.headers['content-disposition']
    let filename = formatDocumentFilename(undefined, undefined, undefined)
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
      )
      if (filenameMatch && filenameMatch[1]) {
        filename = filenameMatch[1].replace(/['"]/g, '')
      }
    }

    link.download = filename
    document.body.appendChild(link)
    link.click()

    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)

    return { success: true }
  } catch (error: any) {
    console.error('Error downloading document:', error)
    throw error
  }
}
